import { useMemo } from "react";
import { UNITS_PER_STEP, LANE_SPACING } from "./constants";

interface TrackProps {
  slotCount: number;
  laneCount: number;
}

// Piste droite simple avec marqueurs de slots et lanes
export function Track({ slotCount, laneCount }: TrackProps) {
  const trackLength = slotCount * UNITS_PER_STEP;
  const trackWidth = Math.max(laneCount, 1) * LANE_SPACING + 2;
  // Centrer les lanes autour de Z=0
  const lanesOffset = ((laneCount - 1) * LANE_SPACING) / 2;

  // Marqueurs de slots (petites barres au sol tous les N steps)
  const slotMarkers = useMemo(() => {
    const markers: JSX.Element[] = [];
    for (let i = 0; i <= slotCount; i += 5) {
      markers.push(
        <mesh
          key={`slot-${i}`}
          position={[i * UNITS_PER_STEP, 0.01, 0]}
          rotation={[-Math.PI / 2, 0, 0]}
          receiveShadow
        >
          <planeGeometry args={[0.08, trackWidth]} />
          <meshStandardMaterial color="#9ca3af" transparent opacity={0.4} />
        </mesh>
      );
    }
    return markers;
  }, [slotCount, trackWidth]);

  // Lignes de lane
  const laneLines = useMemo(() => {
    const lines: JSX.Element[] = [];
    for (let i = 0; i < laneCount; i++) {
      const z = -i * LANE_SPACING + lanesOffset;
      lines.push(
        <mesh
          key={`lane-${i}`}
          position={[trackLength / 2 - UNITS_PER_STEP, 0.01, z]}
          rotation={[-Math.PI / 2, 0, 0]}
          receiveShadow
        >
          <planeGeometry args={[trackLength + 4, 0.025]} />
          <meshStandardMaterial color="#d1d5db" transparent opacity={0.12} />
        </mesh>
      );
    }
    return lines;
  }, [laneCount, lanesOffset, trackLength]);

  return (
    <group>
      {/* Sol principal */}
      <mesh
        position={[trackLength / 2 - UNITS_PER_STEP, -0.05, 0]}
        rotation={[-Math.PI / 2, 0, 0]}
        receiveShadow
      >
        <planeGeometry args={[trackLength + 10, trackWidth + 6]} />
        <meshStandardMaterial color="#7ec87e" />
      </mesh>

      {/* Bande de piste (plus sombre) */}
      <mesh
        position={[trackLength / 2 - UNITS_PER_STEP, 0.005, 0]}
        rotation={[-Math.PI / 2, 0, 0]}
        receiveShadow
      >
        <planeGeometry args={[trackLength + 4, trackWidth]} />
        <meshStandardMaterial color="#a8d5a2" />
      </mesh>

      {/* Ligne de départ */}
      <mesh
        position={[-UNITS_PER_STEP * 0.5, 0.02, 0]}
        rotation={[-Math.PI / 2, 0, 0]}
      >
        <planeGeometry args={[0.15, trackWidth]} />
        <meshStandardMaterial color="#ffffff" />
      </mesh>

      {slotMarkers}
      {laneLines}
    </group>
  );
}
